export default __webpack_public_path__ + "static/logo-white-dfa3f2846a0ae3660a22b98d30ce0ad4.svg";